import React from "react";

const Album = ({
  data: {
    couponName,
    discountType,
    couponNum,
    minLimitValue,
    couponValue,
    activityDate,
    couponCoverUrl
  },
  hasBtn
}) => {
  // console.log(couponName, discountType, couponValue, activityDate);
  return (
    <div className="single-album-box has-coupon add">
      <div className="logo">
        <img src={couponCoverUrl} alt="logo" />
      </div>
      <div className="info">
        <div className="title ellipsis-2 ">{couponName}</div>
        <div className="desc ellipsis-2 ">{activityDate}</div>
      </div>
      <div className="price-btn" style={{ paddingTop: hasBtn ? "" : "1rem" }}>
        <div className="discount-logo">x{couponNum}</div>

        {discountType === "RATE" && (
          <div className="discount">
            <span className="discount-num">{couponValue / 10}</span>
            <span>折</span>
          </div>
        )}
        {discountType === "VALUE" && (
          <div className="cash">
            <span className="rmb">¥</span>
            {couponValue}
          </div>
        )}
        {minLimitValue !== 0 && <p>{`满${minLimitValue}可用`}</p>}
        {discountType === "VALUE" && minLimitValue === 0 && (
          <p style={{ height: "0.3rem" }} />
        )}
        {hasBtn && <div className="btn">立即领取</div>}
      </div>
    </div>
  );
};

export default Album;



// WEBPACK FOOTER //
// ./src/pages/getVipBySign/Album.jsx